import React from 'react';
import { Layout } from './features/components/Layout';
import './App.css';
import withAuthProvider from './utils/AuthProvider';

function App(props) {
  return (
    <div className="App">
        <Layout {...props} />
    </div>
  );
}

export default withAuthProvider(App);
